import React from "react";
import utils from "../../app/UtilityService";
import containerUtils, {
    getEmptyContent,
    resolveChildren,
    dispatchSirenActions
} from "../../utils/containerUtils";
import Scrollbar from "@tinqin/tinqin-ui-components/src/scrollbar";
import DomUtils from "@tinqin/tinqin-utils/src/dom";
import state from "../../app/InternalStateService";

const defaultLoadingThreshold = 80;
//ScrollbarContainer implements UniqueIdContainer functionality
export function ScrollbarContainer(props) {
    const loadMore = () => {
        if (!props.uiState.loadingMore) {
            dispatchSirenActions(props, "loadMore");
        }
    };
    const loadMoreDebounced = DomUtils.debounce(loadMore, 500, true);
    const onUpdate = (scrollMetrics) => {
        let threshold = props.config.loadingThreshold || defaultLoadingThreshold;
        //scrollMetrics.top represents the traversed area as a ratio from 0 to 1
        let visibleContent = Math.round(scrollMetrics.top * 100);
        if (visibleContent > threshold) {
            loadMoreDebounced();
        }
    };
    const data = props.data;
    if (!data) {
        return getEmptyContent();
    }
    const dataProps = data.properties || {};
    const id = dataProps.id || props.computedBindTo;
    const uiState = props.uiState || {};
    const scrollbarContainerProps = containerUtils.extractComponentProps(props, {
        propsDefaults: {
            minHeight: "50px",
            maxHeight: "150px"
        },
        additionalProps: ["minHeight", "maxHeight", "extraClasses"]
    });
    const ScrollLoading = state.getComponent("scrollLoading");

    return (
        <div
            className={scrollbarContainerProps.extraClasses}
            data-unique-id={id}
            data-container-selector={".scrollBarElement>div"}
        >
            <Scrollbar
                hideTracksWhenNotNeeded
                className={"scrollBarElement"}
                autoHeight
                autoHeightMin={scrollbarContainerProps.minHeight}
                autoHeightMax={scrollbarContainerProps.maxHeight}
                onUpdate={onUpdate}
            >
                {resolveChildren(props)}
                {uiState.loadingMore && <ScrollLoading />}
            </Scrollbar>
        </div>
    );
}

//example for issue with inner items with width 100% and padding-right
// <div
//     style={{
//         width: "100%",
//         height: "600px",
//         backgroundColor: "red",
//         paddingRight: "20px"
//     }}
// />
export default utils.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" },
    uiState: true
})(ScrollbarContainer);
